import { LoadableAfterPaint } from '@confluence/loadable';

export const TemplatePreview = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-TemplatePreview" */ '../src/TemplatePreview'))
			.TemplatePreview,
});
